import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class LocationPricingBus extends BaseBus
{
    constructor(data: LocationPricingBus) {
        super(data);
    }

    CID(): any {
        return this.locationPricingId;
    }
    setId(id: any) {
        this.locationPricingId = id;
    }
    initialize(data: LocationPricingBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
       // this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: LocationPricingBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.updateUserId = userId;
        }
    }
    locationPricingId: string;
    locationId: string;
    low: number;
    high: number;
    markup: number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    createdUser : string;
    createdDt : string;
    locationName : string;
    get markupPercent(): number {
        return this.markup * 100;
    }
    set markupPercent(value: number) {
        this.markup = value / 100;
    }
}
